const normalizeErrorMessage = (error) => {
  if (!error) return "";

  if (typeof error === "string") {
    return error.trim();
  }

  const responseData = error?.response?.data;

  if (typeof responseData === "string") {
    return responseData.trim();
  }

  if (typeof responseData?.message === "string") {
    return responseData.message.trim();
  }

  if (typeof responseData?.error === "string") {
    return responseData.error.trim();
  }

  if (Array.isArray(responseData?.errors) && responseData.errors.length > 0) {
    const firstError = responseData.errors.find((value) => typeof value === "string" && value.trim());
    if (firstError) {
      return firstError.trim();
    }
  }

  if (typeof error?.message === "string") {
    return error.message.trim();
  }

  return "";
};

export const translateApiError = (t, error, fallbackKey = "unexpected_error", fallbackText = "Something went wrong. Please try again.") => {
  const message = normalizeErrorMessage(error);

  if (!message) {
    return t(fallbackKey, fallbackText);
  }

  return t(message, message);
};

export default translateApiError;